import { Region } from '@principle-theorem/shared';
import { type IPermission } from './permission';

export enum FeatureVisibility {
  None = 'none',
  Dev = 'dev',
  Alpha = 'alpha',
  OptIn = 'optIn',
  Beta = 'beta',
  Stable = 'stable',
}

export interface IFeature {
  label: string;
  visibility: FeatureVisibility;
  permissions: IPermission[];
  regions?: Region[];
  features?: IFeature[];
}

export const FEATURE_DEFAULTS: Pick<IFeature, 'visibility' | 'permissions'> = {
  visibility: FeatureVisibility.Dev,
  permissions: [],
};
